export const ADMIN_AUDIO_STATUS_LABELS = {
  missing: 'Sin audio',
  needs_recording: 'Falta grabar',
  received: 'Audio cargado',
  processing: 'Procesando audio',
  editing: 'En edición',
  review: 'Listo para revisar',
  ready: 'Audio listo',
  retake: 'Debe regrabar',
  error: 'Error de audio',
};

export const getAdminAudioStatus = (submission) => {
  const workflowStatus = submission?.audio_workflow?.status || '';
  const uploadStatus = submission?.affirmation_audio?.status || '';
  let key = 'missing';

  if (workflowStatus === 'error') key = 'error';
  else if (['auto_processed', 'approved'].includes(workflowStatus)) key = 'ready';
  else if (workflowStatus === 'auto_processing') key = 'processing';
  else if (workflowStatus === 'editing') key = 'editing';
  else if (workflowStatus === 'ready_for_review') key = 'review';
  else if (['audio_retake_requested', 'changes_requested'].includes(workflowStatus)) key = 'retake';
  else if (workflowStatus === 'raw_received' || ['recording_uploaded', 'submitted_to_editor'].includes(uploadStatus)) key = 'received';
  else if (uploadStatus === 'phrases_saved') key = 'needs_recording';

  return { key, label: ADMIN_AUDIO_STATUS_LABELS[key] };
};
